import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://admin.1oneplus.net/api';

const getAuthToken = () => {
    const token = localStorage.getItem("token");
    if (token) return token;

    const user = JSON.parse(localStorage.getItem("userTools"));
    return user?.token;
};

const createAuthHeader = () => {
    const token = getAuthToken();
    const sessionId = sessionStorage.getItem('sessionId');
    const headers = {};
    if (token && token.trim() !== 'social_login_placeholder') {
        headers.Authorization = `Bearer ${token}`;
    } else {
        headers.Authorization = null;
    }
    if (sessionId && sessionId !== 'null' && sessionId !== 'undefined') {
        headers['X-Session-Id'] = sessionId;
    }
    return headers;
};

// Fetch Employees
export const fetchEmployees = createAsyncThunk(
    "order/fetchEmployees",
    async (language, { rejectWithValue }) => {
        try {
            const headers = {
                ...createAuthHeader(),
                'Accept-Language': language || 'en'
            };
            const response = await axios.get(`${BASE_URL}/employees`, { headers });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: "Error fetching employees" });
        }
    }
);

// Fetch Shipping Companies
export const fetchShippingCompanies = createAsyncThunk(
    "order/fetchShippingCompanies",
    async (language, { rejectWithValue }) => {
        try {
            const headers = {
                ...createAuthHeader(),
                'Accept-Language': language || 'en'
            };
            const response = await axios.get(`${BASE_URL}/shippingCompany`, { headers });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: "Error fetching shipping companies" });
        }
    }
);

// Create Order (Checkout)
export const createOrder = createAsyncThunk(
    "order/createOrder",
    async ({ orderData, language }, { rejectWithValue }) => {
        try {
            const headers = {
                ...createAuthHeader(),
                'Accept-Language': language || 'en'
            };
            const response = await axios.post(`${BASE_URL}/orders`, orderData, { headers });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: "Error creating order" });
        }
    }
);

// Fetch Order History
export const fetchOrders = createAsyncThunk(
    "order/fetchOrders",
    async (language, { rejectWithValue }) => {
        try {
            const headers = {
                ...createAuthHeader(),
                'Accept-Language': language || 'en'
            };
            const response = await axios.get(`${BASE_URL}/orders`, { headers });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: "Error fetching order history" });
        }
    }
);
